import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { PASSWORD_REGEX } from "@circle-react/components/OnboardingPage/helpers/constants";
import { useResetPassword } from "@circle-react/hooks/useResetPassword";
import { Button } from "@circle-react-uikit/Button";
import { Form } from "@circle-react-uikit/Form";

interface ResetPasswordFormProps {
  userEmail: string;
}

export const ResetPasswordForm = ({ userEmail }: ResetPasswordFormProps) => {
  const localeScope = "member_profile_modal.authentication";
  const [password, setPassword] = useState("");
  const [isResettingPassword, setIsResettingPassword] = useState(false);

  const { mutate: handleSubmit } = useResetPassword({
    setIsResettingPassword,
  });

  return (
    <Form
      onSubmit={(): void => {
        handleSubmit({
          user: {
            password: password,
            password_confirmation: password,
            email: userEmail,
          },
        });
      }}
    >
      <Form.Item
        id="user_password"
        name="user[password]"
        label={t(`${localeScope}.password`)}
        hideDescription
        hideBorder
        rules={{
          required: t(`${localeScope}.password_required`),
          pattern: {
            value: PASSWORD_REGEX,
            message: t(`${localeScope}.password_invalid`),
          },
        }}
      >
        <Form.Input
          type="password"
          onChange={(e: any) => setPassword(e.target.value)}
          autoComplete="new-password"
        />
      </Form.Item>

      <Form.Item
        id="user_password_confirmation"
        name="user[password_confirmation]"
        label={t(`${localeScope}.password_confirmation`)}
        hideDescription
        hideBorder
        rules={{
          required: t(`${localeScope}.password_required`),
          pattern: {
            value: PASSWORD_REGEX,
            message: t(`${localeScope}.password_invalid`),
          },
          validate: {
            bounds: (value: string) => {
              if (value === password) {
                return true;
              }
              return t(`${localeScope}.password_match`);
            },
          },
        }}
      >
        <Form.Input type="password" autoComplete="new-password" />
      </Form.Item>
      <Form.Item
        hiddenField
        name="user[email]"
        hideDescription
        hideBorder
        hideLabel
      >
        <Form.Input type="hidden" value={userEmail} />
      </Form.Item>
      <div className="mt-6 w-full text-center">
        <div className="mx-auto mb-4 flex w-full">
          <Button
            variant="primary"
            type="submit"
            full
            extraLarge
            disabled={isResettingPassword}
          >
            {t("auth.passwords.edit.change_my_password")}
          </Button>
        </div>
      </div>
    </Form>
  );
};
